import { DefineCustomElements } from "./elements/elements";

import "./core.scss";

import {
  Alert,
  Button,
  Carousel,
  Dropdown,
  Collapse,
  Modal,
  Offcanvas,
  Popover,
  ScrollSpy,
  Tooltip,
} from "bootstrap";

import Helpers from "./helpers"

// Rooting the imports.
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
[Alert, Button, Carousel, Dropdown, Collapse, Modal, Offcanvas, Popover, ScrollSpy, Tooltip];

function initCookies() {
  const consentButton = document.querySelector(
    "#cookie-consent button[data-cookie-string]"
  ) as HTMLButtonElement | null;

  const consentPanel = document.getElementById("cookie-consent") as HTMLElement | null;

  if (consentPanel === null || consentButton === null) {
    return;
  }

  const cookieName = consentButton.dataset.cookieName ?? 'dse.consent';

  let currentCookies: string[];

  try {
    currentCookies = document.cookie.split("; ");
  } catch {
    // Reading document.cookie throws a SecurityError when the document is
    // sandboxed without the 'allow-same-origin' flag. We can neither read nor
    // persist the consent cookie in that context, so leave the panel hidden.
    return;
  }

  if (!currentCookies.some((c) => c.startsWith(cookieName))) {

    consentPanel.style.display = "block";

    consentButton.addEventListener("click", () => {
      try {
        document.cookie = consentButton.dataset.cookieString as string;
      } catch {
        // Cannot persist consent in a sandboxed document; just dismiss the panel.
      }
      consentPanel.style.display = "none";
    });
  }
  else {
    consentPanel.style.display = "none";
  }
}

window.bootstrap = {
  ...window.bootstrap,
  Alert,
  Button,
  Carousel,
  Dropdown,
  Collapse,
  Modal,
  Offcanvas,
  Popover,
  ScrollSpy,
  Tooltip,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).helpers = Helpers

DefineCustomElements();

initCookies();

const contentMain = document.getElementById("content-main");

if (contentMain?.dataset.contentLayout === "section_toc_and_page_toc") {
  new ScrollSpy(document.body, {
    target: "#page-toc-nav",
  });
}

Helpers.InitTooltips();

Helpers.InitPopovers();

Helpers.InitCarousel();
